const gwpRules = {
  ["GWP_BANANA"]: {
    gwpProductId: 42031318892730,
    maxPerOrder: null,
  },
};

if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');

				this.buttonText = this.submitButton.querySelector("span");
				this.buttonPrice = this.submitButton.querySelector(".price-in-btn");
				this.spinner = this.submitButton.querySelector(
					".loading-overlay__spinner",
				);

				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(".loading-overlay__spinner").classList.remove(
					"hidden",
				);

				this.buttonText.classList.add("hidden");
				this.buttonPrice.classList.add("hidden");

				const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
        }
				const formData = new FormData(this.form);
        if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id),
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
        let data = {};
        let gwpRule = "";
        for (let [name, value] of formData.entries()) {
          if (data[name]) {
            // Se já existir, transforma em array (para checkboxes/múltiplos valores)
            data[name] = [].concat(data[name], value);
          } else {
            if (name === "properties[_gwp]") {
              gwpRule = value;
            }
            data[name] = value;
          }
        }

        const { id: productId, sections, ...propreties } = data;
        const payload = {
          items: [{ id: Number(productId), quantity: 1, propreties }],
          sections
        }
        if (gwpRule.length && gwpRules[gwpRule]) {
          payload.items.push({id: gwpRules[gwpRule].gwpProductId, quantity: 1})
        }

				config.body = JSON.stringify(payload);

				fetch(`${routes.cart_add_url}.js`, config)
					.then((response) => response.json())
					.then((response) => {
						const cartHelper = customElements.get("cart-helper");
						const currentProgressBar = document.querySelector(
							".pdp-thermometer .progress-bar-content-status",
						);

						if (currentProgressBar) {
							const freeShippingThresholdType = document.querySelector(
								".free-shipping-threshold-type",
							);
							const freeShippingThresholdOrderValue = document.querySelector(
								".free-shipping-threshold-order-value",
							);
							cartHelper.prototype.updateThermometer(
								response.final_price,
								response.quantity,
								currentProgressBar,
								freeShippingThresholdType,
								freeShippingThresholdOrderValue,
							);
						}

						if (response.status) {
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}
						if (!this.error)
							publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true },
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading-overlay__spinner").classList.add(
							"hidden",
						);

						this.buttonText.classList.remove("hidden");
						this.buttonPrice.classList.remove("hidden");
					});
			}

			handleErrorMessage(errorMessage = false) {
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message",
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		},
	);
}
